var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.9997C1 11.5269 3.08934 10.333 5.66667 10.333C8.244 10.333 10.3333 11.5269 10.3333 12.9997M9.66602 8.33301L13.666 8.33301M9.00065 4.33333C9.00065 6.17428 7.50827 7.66667 5.66732 7.66667C3.82637 7.66667 2.33398 6.17428 2.33398 4.33333C2.33398 2.49238 3.82637 1 5.66732 1C7.50827 1 9.00065 2.49238 9.00065 4.33333Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientRemove);
export default __webpack_public_path__ + "static/media/patientRemove.b257c708b3eb82cb42cbc2123a916688.svg";
export { ForwardRef as ReactComponent };